/* Strawberry Milk Mob theme scripts (no libraries). */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const mm = (window.MilkMob = window.MilkMob || {});

  /* ------------------------------------------------------------------
     Quick add straight from a size on a product card
     ------------------------------------------------------------------ */
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.mm-quick-size');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const variantId = Number(button.dataset.variantId);
    const body = { items: [{ id: variantId, quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }

    button.classList.add('is-loading');
    try {
      const response = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');

      button.classList.remove('is-loading');
      button.classList.add('is-added');
      setTimeout(() => button.classList.remove('is-added'), 1600);

      const item = (data.items && data.items[0]) || data;
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mm-quick-add', productVariantId: variantId, cartData: item });
      }
      if (cart && typeof cart.renderContents === 'function') {
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
        cart.renderContents(Object.assign({}, item, { sections: data.sections }));
        cart.classList.remove('is-empty');
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    } catch (error) {
      button.classList.remove('is-loading');
      button.classList.add('is-error');
      button.setAttribute('title', error.message);
      setTimeout(() => button.classList.remove('is-error'), 2000);
    }
  });

  /* ------------------------------------------------------------------
     Item words (Theme settings > Search behaviour): a search for an item
     ("bathrobe", "sun hats") asks Shopify only for products with that item in
     their name, e.g. "pink robes" -> pink (title:robes OR title:bathrobe OR title:robe).
     Shopify matches plurals itself. Other words in the search still search everything.
     ------------------------------------------------------------------ */
  const searchWords = (s) =>
    String(s || '')
      .toLowerCase()
      .replace(/[’'`]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  const fillerWords = ['the', 'a', 'an', 'and', 'for', 'with', 'in', 'of', 'to', 'my', 'womens', 'women', 'woman', 'ladies', 'girls', 'cute', 'new'];
  let itemGroups = null;
  const getItemGroups = () => {
    if (itemGroups) return itemGroups;
    const list = (s) => String(s || '').split(',').map(searchWords).filter(Boolean);
    itemGroups = String(mm.searchItems || '')
      .split(/\r?\n/)
      .map((line) => {
        const [typed, names] = line.split('=');
        const words = list(typed);
        return { words, names: names === undefined ? words : list(names) };
      })
      .filter((group) => group.words.length && group.names.length);
    return itemGroups;
  };
  const wordForms = (w) => [w, `${w}s`, `${w}es`];

  mm.itemSearch = (query) => {
    const raw = String(query || '').trim();
    // Leave searches that already use Shopify's search syntax alone.
    if (!raw || /[:()"]|\b(OR|AND|NOT)\b/.test(raw)) return null;
    const padded = ` ${searchWords(raw)} `;
    let best = null;
    getItemGroups().forEach((group) => {
      group.words.forEach((w) => {
        wordForms(w).forEach((form) => {
          if (padded.includes(` ${form} `) && (!best || form.length > best.form.length)) best = { group, form };
        });
      });
    });
    if (!best) return null;
    // Other item words and filler words add nothing; anything else (a colour, a print, a name) narrows the results.
    let rest = padded.replace(` ${best.form} `, ' ');
    getItemGroups().forEach((group) => group.words.forEach((w) => wordForms(w).forEach((form) => {
      rest = rest.split(` ${form} `).join(' ');
    })));
    rest = rest.split(' ').filter((w) => w && !fillerWords.includes(w)).join(' ');
    const names = [best.form, ...best.group.names.filter((n) => n !== best.form)];
    const titles = names.map((n) => (n.includes(' ') ? `title:"${n}"` : `title:${n}`)).join(' OR ');
    return `${rest ? `${rest} ` : ''}(${titles})`;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (event.defaultPrevented || !(form instanceof HTMLFormElement)) return;
    const action = (form.getAttribute('action') || '').split('?')[0];
    if (!/\/search\/?$/.test(action)) return;
    const input = form.querySelector('input[name="q"]');
    const item = input && mm.itemSearch(input.value);
    if (!item) return;
    event.preventDefault();
    const params = new URLSearchParams(new FormData(form));
    params.set('q', item);
    window.location.href = `${action}?${params.toString()}`;
  });

  /* ------------------------------------------------------------------
     Size tables: inches / centimetres toggle
     ------------------------------------------------------------------ */
  mm.initSizeTables = (root = document) => {
    const round = (n) => String(Math.round(n * 10) / 10);
    const apply = (unit) => {
      $$('[data-mm-units]').forEach((wrap) => {
        const base = wrap.dataset.base;
        $$('[data-v]', wrap).forEach((cell) => {
          const value = parseFloat(cell.dataset.v);
          if (Number.isNaN(value)) return;
          if (unit === base) cell.textContent = cell.dataset.v;
          else cell.textContent = round(unit === 'cm' ? value * 2.54 : value / 2.54);
        });
      });
      $$('[data-mm-units-toggle] [data-mm-unit]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.mmUnit === unit)));
    };
    mm.applyUnit = apply;
    $$('[data-mm-units-toggle]', root).forEach((toggle) => {
      if (toggle.dataset.mmReady) return;
      toggle.dataset.mmReady = '1';
      toggle.addEventListener('click', (event) => {
        const button = event.target.closest('[data-mm-unit]');
        if (!button) return;
        apply(button.dataset.mmUnit);
        try { localStorage.setItem('mmUnit', button.dataset.mmUnit); } catch (e) {}
      });
    });
    let saved = null;
    try { saved = localStorage.getItem('mmUnit'); } catch (e) {}
    if (saved === 'in' || saved === 'cm') apply(saved);
  };

  /* ------------------------------------------------------------------
     Size guide drawer (loads the size guide page's content once)
     ------------------------------------------------------------------ */
  class MmSizeDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = $('.mm-drawer__panel', this);
      this.body = $('[data-mm-drawer-body]', this);
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-mm-close]')) this.close();
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    async open(opener, focusKind) {
      this.opener = opener;
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.body.classList.add('overflow-hidden');
      await this.load();
      this.focusOn(focusKind);
      if (typeof window.trapFocus === 'function') window.trapFocus(this.panel, this.panel);
      else this.panel.focus();
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
      if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus(this.opener);
      else if (this.opener) this.opener.focus();
      setTimeout(() => { this.hidden = true; }, 380);
    }

    async load() {
      if (this.loaded) return;
      try {
        const response = await fetch(this.dataset.url);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = doc.querySelector('[data-mm-size-guide-content]');
        if (!source) throw new Error('no size guide content');
        this.body.innerHTML = source.innerHTML;
        this.loaded = true;
        mm.initSizeTables(this.body);
      } catch (error) {
        this.body.innerHTML = `<p class="mm-lede"><a class="link" href="${this.dataset.url}">${document.getElementById('MmSizeDrawerTitle').textContent}</a></p>`;
      }
    }

    focusOn(kind) {
      $$('.is-relevant', this.body).forEach((el) => el.classList.remove('is-relevant'));
      if (!kind) return;
      const match = $$('[data-mm-applies]', this.body).find((el) => el.dataset.mmApplies.split(' ').includes(kind));
      if (!match) return;
      match.classList.add('is-relevant');
      const scroller = this.body;
      scroller.scrollTop = Math.max(0, match.offsetTop - scroller.offsetTop - 16);
    }
  }
  if (!customElements.get('mm-size-drawer')) customElements.define('mm-size-drawer', MmSizeDrawer);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mm-size-guide]');
    if (!trigger) return;
    const drawer = document.getElementById('MmSizeDrawer');
    if (!drawer) return;
    event.preventDefault();
    drawer.open(trigger, trigger.dataset.mmSizeGuide);
  });

  /* ------------------------------------------------------------------
     Tabs (product rails, size guide)
     ------------------------------------------------------------------ */
  mm.initTabs = (root = document) => {
    $$('[data-mm-tabs]', root).forEach((wrap) => {
      if (wrap.dataset.mmReady) return;
      wrap.dataset.mmReady = '1';
      const tabs = $$('[role="tab"]', wrap);
      const select = (tab) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          const next = tabs[(i + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          next.focus();
          select(next);
        });
      });
    });
  };


  /* ------------------------------------------------------------------
     Product description: move "Overall fit", "Model description" and
     "Washing instructions" into their own tabs; drop the text list of
     "Mix and match" links (shown as product cards below instead).
     ------------------------------------------------------------------ */
  const cleanFragment = (html) => {
    const template = document.createElement('template');
    template.innerHTML = html;
    template.content.querySelectorAll('[data-canva-clipboard], meta, script, style').forEach((n) => n.remove());
    let changed = true;
    while (changed) {
      changed = false;
      template.content.querySelectorAll('div, p, span, ul, ol, li, b, strong, em, i, br:only-child').forEach((n) => {
        if (!n.textContent.trim() && !n.querySelector('img, iframe, video')) {
          n.remove();
          changed = true;
        }
      });
    }
    return template.content;
  };

  // What follows the "Mix and match" link list or the returns line (for example "All coverups are final sale")
  // stays in Details. The rest of the marker's own line ("Stocking:") and the link list itself are dropped.
  const keepExtra = (html, isMix) => {
    const box = document.createElement('div');
    box.append(cleanFragment(html.replace(/^[^<]*/, '')));
    if (isMix) {
      box.querySelector('ul, ol')?.remove();
      box.querySelectorAll('a').forEach((a) => a.remove());
    } else {
      box.querySelector('a')?.remove();
    }
    if (box.textContent.replace(/[\s,.;:|/&*!-]+/g, '').length < 4) return null;
    return cleanFragment(box.innerHTML);
  };

  mm.splitDescription = (root = document) => {
    $$('[data-mm-details]', root).forEach((wrap) => {
      if (wrap.dataset.mmReady) return;
      wrap.dataset.mmReady = '1';
      const desc = $('[data-mm-desc]', wrap);
      if (!desc) return;
      const html = desc.innerHTML;
      const masked = html.replace(/<[^>]*>/g, (m) => ' '.repeat(m.length));
      const markers = [
        { key: 'fit', re: /overall\s*fit\s*:?/i },
        { key: 'care', re: /washing\s*instructions?\s*:?/i },
        { key: 'mix', re: /(?:shop\s*)?mix\s*(?:and|&amp;|&)\s*match\s*:?/i },
        { key: 'model', re: /model\s*description\s*:?/i },
        { key: 'policy', re: /check\s*out\s*our\s*return[^.<]*/i },
      ];
      const found = [];
      markers.forEach((m) => {
        const match = m.re.exec(masked);
        if (match) found.push({ key: m.key, index: match.index, length: match[0].length });
      });
      if (!found.length) return;
      found.sort((a, b) => a.index - b.index);

      const chunks = {};
      found.forEach((f, i) => {
        const end = i + 1 < found.length ? found[i + 1].index : html.length;
        chunks[f.key] = html.slice(f.index + f.length, end);
      });

      const intro = cleanFragment(html.slice(0, found[0].index));
      desc.innerHTML = '';
      desc.append(intro);
      ['mix', 'policy'].forEach((key) => {
        const extra = chunks[key] && keepExtra(chunks[key], key === 'mix');
        if (extra) desc.append(extra);
      });
      const detailsTab = desc.closest('details');
      if (!desc.textContent.trim() && detailsTab) detailsTab.remove();

      const fitTab = $('[data-mm-acc="fit"]', wrap);
      const fitSlot = $('[data-mm-fit-slot]', wrap);
      if (fitTab && fitSlot && (chunks.fit || chunks.model)) {
        if (chunks.fit) {
          const text = cleanFragment(chunks.fit).textContent.replace(/\s+/g, ' ').trim();
          if (text) {
            const p = document.createElement('p');
            const strong = document.createElement('strong');
            strong.textContent = `${fitSlot.dataset.labelFit || 'Overall fit'}: `;
            p.append(strong, text);
            fitSlot.append(p);
          }
        }
        if (chunks.model) {
          const model = cleanFragment(chunks.model);
          if (model.textContent.trim()) {
            const p = document.createElement('p');
            const strong = document.createElement('strong');
            strong.textContent = fitSlot.dataset.labelModel || 'Model sizes';
            p.append(strong);
            fitSlot.append(p, model);
          }
        }
        if (fitSlot.textContent.trim()) fitTab.hidden = false;
      }

      const careTab = $('[data-mm-acc="care"]', wrap);
      const careSlot = $('[data-mm-care-slot]', wrap);
      if (careTab && careSlot && chunks.care) {
        const text = cleanFragment(chunks.care).textContent.replace(/\s+/g, ' ').trim();
        if (text) {
          const p = document.createElement('p');
          p.textContent = text;
          careSlot.append(p);
          careTab.hidden = false;
        }
      }

      if (!$('details[open]', wrap)) {
        const first = $('details:not([hidden])', wrap);
        if (first) first.open = true;
      }
    });
  };

  /* ------------------------------------------------------------------
     Sticky "Add to bag" bar on phones
     ------------------------------------------------------------------ */
  mm.initStickyAtc = () => {
    const info = document.querySelector('product-info[id^="MainProduct-"]');
    if (!info || document.querySelector('.mm-sticky-atc')) return;
    const getSubmit = () => info.querySelector('.product-form__submit');
    if (!getSubmit()) return;

    const title = (info.querySelector('.product__title h1') || {}).textContent || '';
    const image = info.querySelector('.product__media img');
    const label = info.dataset.mmStickyLabel || 'Add to bag';
    const bar = document.createElement('div');
    bar.className = 'mm-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = `
      <div class="mm-sticky-atc__img">${image ? `<img src="${image.currentSrc || image.src}" alt="" loading="lazy">` : ''}</div>
      <div class="mm-sticky-atc__info"><p class="mm-sticky-atc__title"></p><p class="mm-sticky-atc__meta"></p></div>
      <button type="button" class="button" tabindex="-1"></button>`;
    bar.querySelector('.mm-sticky-atc__title').textContent = title.trim();
    document.body.appendChild(bar);
    const meta = bar.querySelector('.mm-sticky-atc__meta');
    const button = bar.querySelector('button');

    const update = () => {
      const submit = getSubmit();
      const checked = info.querySelector('.product-form__input--pill input:checked');
      const size = checked && checked.nextElementSibling ? checked.nextElementSibling.firstChild.textContent.trim() : '';
      const priceEl = info.querySelector('.price__sale:not([hidden]) .price-item--sale, .price__regular .price-item--regular');
      const price = priceEl ? priceEl.textContent.trim() : '';
      meta.textContent = [size, price].filter(Boolean).join(' · ');
      const soldOut = submit && submit.disabled;
      button.textContent = soldOut ? submit.textContent.trim() : label;
      button.disabled = !!soldOut;
    };
    update();

    button.addEventListener('click', () => {
      const submit = getSubmit();
      if (submit && !submit.disabled) submit.click();
    });

    const observer = new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      bar.setAttribute('aria-hidden', String(!past));
    });
    observer.observe(info.querySelector('.product-form__buttons') || getSubmit());

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(update, 50));
    }
    info.addEventListener('change', () => setTimeout(update, 400));
  };

  /* ------------------------------------------------------------------
     Product info column: when it is taller than the screen, let it
     scroll with the page and stick by its bottom edge instead.
     ------------------------------------------------------------------ */
  mm.initStickyInfo = () => {
    const column = document.querySelector('.product__column-sticky');
    if (!column || !('ResizeObserver' in window)) return;
    const desktop = window.matchMedia('(min-width: 750px)');
    const set = () => {
      if (!desktop.matches) {
        column.style.top = '';
        return;
      }
      const offset = 24;
      const height = column.offsetHeight;
      const room = window.innerHeight;
      column.style.top = height + offset * 2 > room ? `${room - height - offset}px` : `calc(var(--mm-header-offset, 0px) + ${offset}px)`;
    };
    new ResizeObserver(set).observe(column);
    window.addEventListener('resize', set);
    set();
  };

  const init = (root) => {
    mm.initSizeTables(root);
    mm.initTabs(root);
    mm.splitDescription(root);
    if (root === document) {
      mm.initStickyAtc();
      mm.initStickyInfo();
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
